<div class="lang-selector" [class.open]="isOpen">
  <button class="lang-btn" type="button" (click)="toggleDropdown()">
    <span class="lang-icon">
      <i class="fa fa-globe"></i>
    </span>
    <span class="lang-current">{{ currentLangLabel }}</span>
    <i class="fa fa-chevron-down lang-caret"></i>
  </button>
  <div class="lang-dropdown" *ngIf="isOpen">
    <div
      *ngFor="let lang of supportedLanguages"
      class="lang-option"
      [class.active]="lang.code === i18n.currentLang"
      (click)="selectLanguage(lang.code)">
      {{ lang.label }}
    </div>
  </div>
</div>
